import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const create = async (data) => axiosRequest({
  url: '/v1/fileCommissionDeviations/create',
  method: 'POST',
  data,
  headers: defaultHeaders,
});

const update = async (data) => axiosRequest({
  url: '/v1/fileCommissionDeviations/update',
  method: 'POST',
  data,
  headers: defaultHeaders,
});

const updateMultiple = async (data) => axiosRequest({
  url: '/v1/fileCommissionDeviations/updateMany',
  method: 'POST',
  data,
  headers: defaultHeaders,
});

const getAll = async (data) => axiosRequest({
  url: '/v1/fileCommissionDeviations/getAll',
  method: 'POST',
  data,
  headers: defaultHeaders,
});

export {
  create,
  update,
  updateMultiple,
  getAll,
};
